import { render, staticRenderFns } from "./hoverEllipsis.vue?vue&type=template&id=3264b828&scoped=true"
import script from "./hoverEllipsis.vue?vue&type=script&lang=js"
export * from "./hoverEllipsis.vue?vue&type=script&lang=js"
import style0 from "./hoverEllipsis.vue?vue&type=style&index=0&id=3264b828&prod&lang=scss&scoped=true"
import style1 from "./hoverEllipsis.vue?vue&type=style&index=1&id=3264b828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264b828",
  null
  
)

export default component.exports